import type { DraftPlayer } from '../types'
import { BenchSlot } from './BenchSlot'
import styles from './BenchSection.module.css'

type BenchSectionProps = {
  benchGk:        DraftPlayer | null
  bench:          readonly DraftPlayer[]   // outfield subs, max 3
  isWindowOpen:   boolean
  subbedInIds?:   ReadonlySet<string>
  onRemove?:      (playerId: string) => void
  onClickPlayer?: (playerId: string) => void
}

const OUTFIELD_LABELS = ['Sub 1', 'Sub 2', 'Sub 3'] as const

export function BenchSection({
  benchGk,
  bench,
  isWindowOpen,
  subbedInIds,
  onRemove,
  onClickPlayer,
}: BenchSectionProps) {
  return (
    <div className={styles.section}>
      <h3 className={styles.heading}>Banco de Reservas</h3>

      <div className={styles.row}>
        {/* GK bench — only swaps with starting GK, handled in useSquadDnd */}
        <BenchSlot
          player={benchGk}
          dndId="bench-gk"
          label="GR"
          enableDnd={true}
          isWindowOpen={isWindowOpen}
          isSubbedIn={benchGk !== null && (subbedInIds?.has(benchGk.playerId) ?? false)}
          {...(onRemove !== undefined ? { onRemove } : {})}
          {...(onClickPlayer !== undefined ? { onClickPlayer } : {})}
        />

        {/* Outfield subs — draggable to/from pitch */}
        {OUTFIELD_LABELS.map((label, i) => {
          const p = bench[i] ?? null
          return (
            <BenchSlot
              key={i}
              player={p}
              dndId={`bench-${i}`}
              label={label}
              enableDnd={true}
              isWindowOpen={isWindowOpen}
              isSubbedIn={p !== null && (subbedInIds?.has(p.playerId) ?? false)}
              {...(onRemove !== undefined ? { onRemove } : {})}
              {...(onClickPlayer !== undefined ? { onClickPlayer } : {})}
            />
          )
        })}
      </div>
    </div>
  )
}
